module.exports = __webpack_public_path__ + "img/img10.6637d191.jpg";